import router from '@/router'
import { mainStatus, UserHome, AdminHome } from '@/types/constant'
import userInfoHook from '@/hooks/useUserInfo'
const { isDomesticConsumer } = userInfoHook()
const {
    awaitConfirm,
    awaitVerify,
    waitDelivery,
    awaitAudit,
    sendBack,
    passAudit
} = mainStatus

export function toDetail(query: any) {
    const path = isDomesticConsumer.value
        ? '/filing_browsing'
        : '/filing_info_browsing'
    return router.push({
        path,
        query
    })
}

// 获取路由信息
export function getQuery() {
    return router?.currentRoute?.value?.query
}

// 获取路由ID
export function getMainId() {
    return getQuery().nav_main_id || ''
}

// 待确认详情
export function awaitComfirmDetail(query: any) {
    return toDetail({ web_status: awaitConfirm, ...query })
}

// 待核实详情
export function awaitVerifyDetail(query: any) {
    return toDetail({ web_status: awaitVerify, ...query })
}

// 待上交详情
export function awaitHandInDetail(query: any) {
    return toDetail({ web_status: waitDelivery, ...query })
}

// 等待管局审核详情
export function awaitAuditDetail(query: any) {
    return toDetail({ web_status: awaitAudit, ...query })
}

// 审核退回详情
export function sendBackInfoDetail(query: any) {
    return toDetail({ web_status: sendBack, ...query })
}

// 审核通过详情
export function passAuditDetail(query: any) {
    return toDetail({ web_status: passAudit, ...query })
}

// 提交备案信息成功跳转
export function submitFilingSuccess(query: any = {}) {
    let path = '/icp_filing_admin/await_comfirm'
    if (isDomesticConsumer.value) {
        const id = getMainId()
        path = '/filing_browsing'
        if (id) {
            query = { id, main_status: 0, tab: 2 }
        }
    }
    return router.push({
        path,
        query
    })
}

// 取消备案、接入跳转
export function calcelFilingSuccess(query: any = {}) {
    const path = isDomesticConsumer.value
        ? '/filing_new/filing_history-queren'
        : '/icp_filing_admin/await_comfirm'
    return router.push({
        path,
        query
    })
}

// 登录成功
export function loginSuccess() {
    const path = isDomesticConsumer.value ? UserHome : AdminHome
    return router.push({
        path
    })
}
